/**
 * How long something took, said in the units a person would use.
 *
 * A stored millisecond count printed as minutes produced "outlived its 60m timeout by 15598m"
 * — ten and a half days, wearing the unit it was stored in. Largest two units, so a ten-day
 * overrun is `10d 20h` and a ninety-minute span is `1h 30m`.
 */
export function humaneDuration(ms: number): string {
  if (!Number.isFinite(ms) || ms < 0) return '—';
  const seconds = Math.round(ms / 1000);
  if (seconds < 60) return `${seconds}s`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) {
    const rest = seconds % 60;
    return rest === 0 ? `${minutes}m` : `${minutes}m ${rest}s`;
  }
  const hours = Math.floor(minutes / 60);
  if (hours < 24) {
    const rest = minutes % 60;
    return rest === 0 ? `${hours}h` : `${hours}h ${rest}m`;
  }
  const days = Math.floor(hours / 24);
  const restH = hours % 24;
  return restH === 0 ? `${days}d` : `${days}d ${restH}h`;
}
